// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-166e6650]{display:flex;padding:4px 8px;justify-content:center;align-items:center;gap:4px;border-radius:8px;background:var(--background-bg-medium,#111924);color:var(--text-text-medium,#c6c8cd);font-size:12px;font-style:normal;font-weight:400;line-height:16px;letter-spacing:.21px;white-space:nowrap}.badge.special[data-v-166e6650]{background:var(--jw-color-gold,#fbc500);color:#000}", ""]);
// Exports
module.exports = exports;
